import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export interface ScheduledClass {
    id: number;
    class_title: string;
    from_time: string;
    to_time: string;
    tutor_id: number;
    subject_id: number;
    question_type_id: number;
    meeting_link: string;
    description: string;
    status: boolean;
    created_at: string;
    participant_count: number;
    total_participants?: number;
    tutor?: { id: number; username: string };
    subject?: { id: number; name: string };
    question_type?: { id: number; name: string };
    participants?: any[];
    worksheets?: any[];
    sample_booklets?: any[];
}

export interface ScheduledClassesFilter {
    tutor_id?: number;
    status_filter?: boolean;
    date_filter?: string;
    question_type_id?: number;
    subject_id?: number;
    limit?: number;
    page?: number;
    order_by?: "ASC" | "DESC";
    class_id?: number;
    search_string?: string;
}

export type ScheduledClassesResponse = {
    data: ScheduledClass[];
    total_count: number;
    total_pages: number;
    current_page: number;
} | ScheduledClass[] | ScheduledClass;


const initialState: IReduxState<ScheduledClassesResponse> = {} as IReduxState<ScheduledClassesResponse>;

export const ScheduledClassesSlice = createSlice({
    name: "ScheduledClassesSlice",
    initialState,
    reducers: {
        getScheduledClasses: (state, _action: PayloadAction<ScheduledClassesFilter>) => {
            state.isLoading = true;
            state.error = null;
        },
        successGetScheduledClasses: (state, action: PayloadAction<any>) => {
            state.isLoading = false;
            state.data = action.payload;
        },
        failureGetScheduledClasses: (state, action: PayloadAction<any>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
});

export const {
    getScheduledClasses,
    successGetScheduledClasses,
    failureGetScheduledClasses,
} = ScheduledClassesSlice.actions;

export default ScheduledClassesSlice.reducer;
